import { ISurveyPlugin } from "../../plugin-host/plugin.interface";

export const page_timer_plugin: ISurveyPlugin = {
  id: 'page-timer-tracker',
  name: 'Page Time Tracker',
  config: {
    show_timer_to_user: true,
    variable_prefix: 'time_spent_page_',
  },
  variablesSchema: [{ key: 'time_spent_seconds', type: 'number' }],
  html: "<div id='timer-container' style='font-family: sans-serif; font-size: 13px; color: #666; margin-bottom: 10px; display: none;'>Time on page: <span id='timer-display'>0</span>s</div>",
  hooks: {
    onPageInit: `
      context.startTime = Date.now();
      // Accessing the page ID from the renderStore via context
      context.currentPageId = context.registry ? Object.values(context.registry)[0]?.pageId : 'unknown';

      if (context.config.show_timer_to_user) {
        const container = context.container.querySelector('#timer-container');
        const display = context.container.querySelector('#timer-display');
        if(container) container.style.display = 'block';

        context.timerInterval = setInterval(() => {
          const seconds = Math.floor((Date.now() - context.startTime) / 1000);
          if (display) display.innerText = seconds;
        }, 1000);
      }
    `,
    onBeforeSubmit: `
      const totalSeconds = Math.round((Date.now() - context.startTime) / 1000);
      
      // Dynamic key so page 1 and page 2 both get saved
      // Result: { time_spent_page_1: 45, time_spent_page_2: 30 }
      context.setVariable('SCREENTIME_'+context.pageId, totalSeconds);

      if (context.timerInterval) clearInterval(context.timerInterval);
    `,
    onCleanup: `
      if (context.timerInterval) clearInterval(context.timerInterval);
    `,
  },
  version: '',
  configSchema: {},
};
